import { useInfiniteQuery } from '@tanstack/react-query'
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'

import { QUERY_KEY } from '../../../constants'

import { getNewsCategories, getNewsList } from '../../../api/news'

import { StoresContext } from '../../../provider/StoreProvider'

import { Head } from '../../../components/head/Head'
import { Wrap } from '../../../components/container/Wrap'
import { CenterWrap, AlignCenterItem } from '../../../components/common'
import { Content } from '../../../components/container/Content'
import { Header } from '../../../components/header'
import { InfinityScroll } from '../../../components/pagingList/InfinityScroll'
import { Category } from '../../../components/paramOption/Category'
import { Spinner } from '../../../components/spinner/Spinner'
import { NotificationList, NotificationItem } from '../../notification/components/List'

const HEAD_INFO = {
  title: '뉴스 | 미술품 조각투자 플랫폼, 아티피오',
  ogTitle: '뉴스 | 미술품 조각투자 플랫폼, 아티피오',
  ogUrl: window.location.href,
}

export function News() {
  const {
    commonStore: { setShowTab },
  } = useContext(StoresContext)

  const [categoryId, setCategoryId] = useState<number | undefined>(undefined)

  const {
    data: categoryData,
    isPending: isCategoryPending,
    isError: isCategoryError,
  } = useInfiniteQuery({
    queryKey: [QUERY_KEY.disclosureCategories],
    queryFn: async () => await getNewsCategories({ offset: 0, size: 50 }),
    getNextPageParam: () => undefined,
    initialPageParam: 0,
    select: (data) => ({
      ...data,
      pages: data.pages.map((page) => page.list).flat(),
    }),
  })
  const { data, isPending, isError, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: [QUERY_KEY.news, { categoryId }],
    queryFn: async ({ pageParam = 0 }) => await getNewsList({ categoryId, offset: pageParam, size: 50 }),
    getNextPageParam: (lastPage) => (lastPage.last ? undefined : lastPage.offset + lastPage.size),
    initialPageParam: 0,
    select: (data) => ({
      ...data,
      pages: data.pages.map((page) => page.list).flat(),
    }),
  })

  useEffect(() => {
    setShowTab(false)
  }, [])

  if (isPending || isError || isCategoryPending || isCategoryError) {
    return (
      <>
        <Head {...HEAD_INFO} />
        <Wrap>
          <CenterWrap>
            <Spinner />
          </CenterWrap>
        </Wrap>
      </>
    )
  }

  return (
    <>
      <Head {...HEAD_INFO} />
      <Wrap>
        <Header type="SUB" title="뉴스" />
        <StyledContent id="infinity-scroll-target">
          <Category
            categoryList={categoryData.pages}
            categoryId={categoryId}
            setCategoryId={(id) => setCategoryId(id === -1 ? undefined : id)}
          />
          <InfinityScroll length={data.pages.length} isLast={!hasNextPage} next={fetchNextPage}>
            <NotificationList>
              {data.pages.map(({ id, categoryId, title, createdDate, linkUrl }) => {
                const categoryName = categoryData.pages.find((v) => v.id === categoryId)?.name

                const locationNews = () => window.open(linkUrl)

                return (
                  <NotificationItem key={id} onClick={locationNews} style={{ cursor: 'pointer' }}>
                    <AlignCenterItem className="notification-type" $gap={6}>
                      <NotificationItem.Type>{categoryName ?? ''}</NotificationItem.Type>
                    </AlignCenterItem>
                    <NotificationItem.Title>{title}</NotificationItem.Title>
                    <NotificationItem.Date>{createdDate}</NotificationItem.Date>
                  </NotificationItem>
                )
              })}
            </NotificationList>
          </InfinityScroll>
        </StyledContent>
      </Wrap>
    </>
  )
}

const StyledContent = styled(Content)`
  gap: 8px;
  padding-top: 8px;
`
